let isUpdating = false, lastUpdateTime = 0, isInitialized = false;
const giftStates = new Map(), UPDATE_DELAY = 500, RESIZE_DELAY = 500;
let giftObserver = null, resizeTimeout = null;
const isMobile = () => window.innerWidth <= 992;
const isZeroPrice = (priceText) => {
  if (!priceText) return false;
  const cleaned = priceText.replace(/[^\d,.\-]/g, '').replace(/,/g, '.');
  const numericValue = parseFloat(cleaned);
  return !isNaN(numericValue) && numericValue === 0;
};
const getStateKey = el => {
  const s = el.querySelector('.rebuy-money.sale span:last-child');
  const c = el.querySelector('.rebuy-money.compare-at span:last-child');
  return `${s?.textContent.trim() || ''}_${c?.textContent.trim() || ''}_${isMobile()}`;
};
const getGiftState = el => {
  const q = el.querySelector('.rebuy-cart__flyout-item-quantity');
  if (!q) return null;
  const s = el.querySelector('.rebuy-money.sale span:last-child');
  const c = el.querySelector('.rebuy-money.compare-at span:last-child');
  return {
    quantityBlock: q,
    salePriceSpan: s,
    comparePriceSpan: c,
    existingInfo: q.querySelector('.gift-info'),
    salePrice: s?.textContent.trim() || '',
    comparePrice: c?.textContent.trim() || '',
    isMobile: isMobile()
  };
};
const updateGiftTextOnly = () => {
  const text = isMobile() ? 'FREE' : 'FREE GIFT';
  document.querySelectorAll('.property-key-_gifted .free-gift-label').forEach(el => {
    if (el.textContent !== text) el.textContent = text;
  });
};
const replaceGiftPrice = () => {
  document.querySelectorAll('.property-key-_gifted').forEach(el => {
    const state = getGiftState(el);
    if (!state) return;
    const { quantityBlock, salePriceSpan, comparePriceSpan, existingInfo, salePrice, comparePrice } = state;
    const key = getStateKey(el);
    if (giftStates.get(el) === key && existingInfo) return;
    giftStates.set(el, key);
    if (salePriceSpan && isZeroPrice(salePrice)) {
      Object.assign(salePriceSpan.style, { color: '#06A067', fontWeight: 'bold', fontSize: '18px' });
      salePriceSpan.textContent = 'FREE';
    }
    if (existingInfo) existingInfo.remove();
    const container = document.createElement('div');
    container.className = 'gift-info';
    if (salePriceSpan?.textContent.trim() === 'FREE') {
      const label = document.createElement('span');
      label.className = 'free-gift-label';
      label.textContent = isMobile() ? 'FREE' : 'FREE GIFT';
      container.appendChild(label);
    }
    if (comparePriceSpan && !isZeroPrice(comparePrice)) {
      const worth = document.createElement('span');
      worth.className = 'worth-label';
      worth.textContent = `Worth ${comparePrice}`;
      container.appendChild(worth);
    }
    if (container.children.length) quantityBlock.appendChild(container);
  });
};
const updateGiftInfo = (force = false) => {
  const now = Date.now();
  if (!force && (isUpdating || now - lastUpdateTime < UPDATE_DELAY)) return;
  isUpdating = true;
  lastUpdateTime = now;
  try { replaceGiftPrice(); } finally { isUpdating = false; }
};
const setupGiftObserver = () => {
  let timeoutId = null, isProcessing = false;
  const observer = new MutationObserver(mutations => {
    if (isProcessing) return;
    const hasGiftChanges = mutations.some(m => {
      if (m.type === 'childList') {
        return [...m.addedNodes, ...m.removedNodes].some(n =>
          n.nodeType === 1 && (n.classList?.contains('property-key-_gifted') ||
            n.querySelector?.('.property-key-_gifted'))
        );
      }
      if (m.type === 'characterData' && m.target.parentElement) {
        return !!m.target.parentElement.closest?.('.property-key-_gifted');
      }
      return false;
    });
    if (hasGiftChanges) {
      isProcessing = true;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => { updateGiftInfo(); timeoutId = null; isProcessing = false; }, 300);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  return observer;
};
const init = () => {
  if (isInitialized) return;
  setTimeout(() => { updateGiftInfo(true); isInitialized = true; }, 500);
  giftObserver = setupGiftObserver();
  let lastResizeTime = 0;
  window.addEventListener('resize', () => {
    const now = Date.now();
    if (now - lastResizeTime < RESIZE_DELAY) return;
    lastResizeTime = now;
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (document.querySelectorAll('.property-key-_gifted').length) updateGiftTextOnly();
      resizeTimeout = null;
    }, 300);
  });
};
// document.addEventListener('DOMContentLoaded', init);
// window.addEventListener('load', () => {
//   if (!isInitialized) setTimeout(() => { updateGiftInfo(true); isInitialized = true; }, 1000);
// });
// window.addEventListener('beforeunload', () => {
//   giftObserver?.disconnect();
//   clearTimeout(resizeTimeout);
//   giftStates.clear();
// });